import Vue from "vue";
import api from "@/api";

import deepClone from "@/utils/deep-clone";

const state = {
    details: {},
    attachmentUrl: "",
};

const getters = {
    details(state) {
        return id => deepClone(state.details[id]);
    },
    attachmentUrl(state) {
        return state.attachmentUrl;
    },
};

const actions = {
    get({ commit }, { payload: { id } }) {
        return api.get(`/api/users/details/${id}`).then(res => {
            commit("updateDetails", { user: res.data });
        });
    },
    update(_, { payload: { user, scope } }) {
        return api.post(`/api/users/update/user`, { user, scope });
    },
    deactivate(_, { payload: { id } }) {
        return api.post(`/api/users/deactivate`, { user: id });
    },
    reactivate(_, { payload: { id } }) {
        return api.post(`/api/users/reactivate`, { user: id });
    },
    remove(_, { payload: { id } }) {
        return api.post(`/api/users/remove/superAdmin`, { user: id });
    },
    getSingleAttachment({ commit }, { payload: { key } }) {
        return api.get(`/api/users/attachment/${key}`).then(res => {
            commit("updateAttachmentUrl", { attachmentUrl: res.data });
        });
    },
    setOneTimePassword({ commit }, { payload: { id } }) {
        return api.post(`/api/users/password/setOneTimePassword`, { userId: id }).then(res => {
            commit("updateOneTimePassword", { userId: id, oneTimePassword: res.data });
        });
    },
};

const mutations = {
    updateDetails(state, { user }) {
        Vue.set(state.details, user._id, user);
    },
    updateOneTimePassword(state, { userId, oneTimePassword }) {
        Vue.set(state.details[userId], "oneTimePassword", oneTimePassword);
    },
    updateAttachmentUrl(state, { attachmentUrl }) {
        state.attachmentUrl = attachmentUrl;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
